import $ from 'jquery'

$('.js-mobile-nav .dropdown-toggle').on('click', function() {
  $(this).next().slideToggle('fast')
})